import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';

import { extractParams } from 'helpers/InitHelpers';
import { extractQueryParameters } from 'helpers/RoutesHelpers';
import {
    initContactSupportApp,
    openModal,
} from './reduxModules/App';

import SupportModal from './components/SupportModal';

export const appSelector = '#js-app-contact-form';
const portalRoot = document.querySelector(appSelector);

class SupportModalPortal extends Component {

    constructor(props) {
        super(props);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.element = document.createElement('div');
    }

    componentDidMount() {
        const { AppActions } = this.props;
        const params = extractParams(appSelector);
        const orgaId = Number.parseInt(params['orga-id'], 10);
        AppActions.initContactSupportApp(orgaId);
        portalRoot.appendChild(this.element);
    }

    componentWillUnmount() {
        portalRoot.removeChild(this.element);
    }

    onOpenModal() {
        const { AppActions } = this.props;
        AppActions.openModal({});
    }

    renderPortalContent() {
        const { history } = this.props;
        const supportModalLocation = {
            pathname: '',
            search: '',
            hash: '',
        };
        if (history && history.location) {
            supportModalLocation.pathname = extractQueryParameters(history.location.search)['support-modal'] || '';
        }
        return (
            <>
                <SupportModal history={history} location={supportModalLocation} />
                <a
                    className="p-3"
                    onClick={this.onOpenModal}
                >
                    Aide
                </a>
            </>
        );
    }

    render() {
        return ReactDOM.createPortal(
            this.renderPortalContent(),
            this.element,
        );
    }

}

SupportModalPortal.propTypes = {
    AppActions: PropTypes.shape({
        initContactSupportApp: PropTypes.func.isRequired,
        openModal: PropTypes.func.isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
    exhibitId: PropTypes.number,
};

SupportModalPortal.defaultProps = {
    exhibitId: null,
};

const ConnectedApp = withRouter(
    connect(undefined, (dispatch) => ({
        AppActions: bindActionCreators({
            initContactSupportApp,
            openModal,
        }, dispatch),
    }))(SupportModalPortal),
);

export default ConnectedApp;
